// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"12":"profiler","777":"recorder"}[chunkId] || chunkId) + "." + {"12":"385de427","288":"a69e84de","333":"f56b92b3","584":"5a0f49f8","757":"2784b8c5","777":"978fe4b0","779":"e750f2e1","875":"b37fad64"}[chunkId] + ".chunk.js";
};